import React from "react";
import { Form, FormGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { TemplateFieldV2 } from "../../../../../docuclipper/DocuclipperTypes";
import { updateRegex } from "../../../../../redux/reducers/TemplateField";
import PopoverHelp from "../../../../Docuclipper/PopoverHelp";
import { withSelectedField } from "../withSelectedField";
type Props = {
  field: TemplateFieldV2;
};

const getValue = (field, fieldName) => {
  let value = "";
  if (field && field.qbo && field.qbo.regex && field.qbo.regex[fieldName]) {
    value = field.qbo.regex[fieldName];
  }
  return value;
};

const QboRegex: React.SFC<Props> = ({ field }) => {
  const dispatch = useDispatch();

  return (
    <div>
      <Form.Label>
        <strong>Field Regex</strong>
        <PopoverHelp header="" id="regex" placement="bottom">
          Only data that matches the "regex" expression will be included in the
          output.
        </PopoverHelp>
      </Form.Label>
      {["date", "name", "amount", "debit", "credit", "balance"].map(
        (fieldName) => (
          <FormGroup>
            <Form.Label>
              <strong>{fieldName}</strong>
            </Form.Label>
            <Form.Control
              value={getValue(field, fieldName)}
              onChange={(e) =>
                dispatch(
                  updateRegex({
                    id: field.id,
                    fieldName,
                    regex: e.target.value,
                  })
                )
              }
            />
          </FormGroup>
        )
      )}
    </div>
  );
};

export default withSelectedField(QboRegex);
